import { Page, StyleSheet, Text, View } from '@react-pdf/renderer';
import React, { Fragment } from 'react';
import { displayFormattedDate, formatCurrency } from '../../../generalFunctions';
import { FIRM_NAME } from '../../../constants';

const styles = StyleSheet.create({
    rowView: {
        flexDirection: 'row', border: '1px solid #000', padding: 10, textAlign: "center", alignSelf: "flex-start", marginRight: 25
    }
});

const PeriodwiseTotalTDSList = (props) => {
    const { startDate, endDate } = props.dates;
    let totalTDS = 0; let totalAmount = 0;
    props.data?.forEach((element, index) => {
        element.receiptDate = displayFormattedDate(element.receiptDate);
        totalTDS = totalTDS + element.tds;
        totalAmount = totalAmount + element.amount;
        element.amount = Number(element.amount).toFixed(2);
        element.tds = Number(element.tds).toFixed(2);
    });

    props.data.push({
        amount: Number(totalAmount).toFixed(2),
        tds: Number(totalTDS).toFixed(2)
    });

    const tableData = {
        columnName: ["Date", "Receipt No", "A/C Name", "Bank", "TDS Amt", "Cheque No", "Cheque Dt", "Cheque Amt"],
        column: ["receiptDate", "id", "accountName", "bankName", "tds", "chequeNumber", "chequeDate", "amount"],
        width: [10, 10, 20, 20, 10, 10, 10, 10],
        data: props.data
    }

    return (
        <Page style={{ padding: 15 }} id={props.data.id} orientation="landscape">
            <View style={{ flexDirection: "row", paddingBottom: 5, paddingTop: 7, alignSelf: "center" }}>
                <Text style={{
                    fontSize: 16,
                    flexDirection: "column",
                    flexGrow: 1
                }}>{FIRM_NAME}</Text>
            </View>
            <View style={{ flexDirection: 'row', textAlign: "center", marginBottom: 15 }}>
                <Text style={{ fontSize: 9, fontWeight: "bold" }}>{`T.D.S. Record for the period: ${displayFormattedDate(startDate)} To ${displayFormattedDate(endDate)} (Only Receivable)`}</Text>
            </View>
            <Fragment>
                <View style={styles.rowView}>
                    {tableData["columnName"].map((c, index) => <Text key={index} style={{
                        width: `${tableData["width"][index]}%`, fontSize: 9
                    }}>{c.toUpperCase()}</Text>)}
                </View>
                {tableData["data"].map((rowData) => <>
                    <View style={styles.rowView}>
                        {tableData["column"].map((c, index) =>
                            <Text key={index} style={{ width: `${tableData["width"][index]}%}%`, fontSize: 9 }}>{rowData[c]}</Text>
                        )}
                    </View>
                </>)}
            </Fragment>
        </Page>
    );
}

export default PeriodwiseTotalTDSList;